import { store } from '../store/store.js';

export let GoogleAnalytics = {
  loadIfConfigured() {
    if (!this.isEnabled()) {
      return Promise.resolve();
    }
    if (this.shouldDownloadScript()) {
      return this.downloadScript().then(() => {
        this.setUp();
      });
    } else {
      this.setUp();
      return Promise.resolve();
    }
  },
  isEnabled() {
    return store.getters.isGoogleAnalyticsEnabled;
  },
  shouldDownloadScript() {
    return true;
  },
  downloadScript() {
    return new Promise((resolve, reject) => {
      var s;
      s = window.document.createElement('script');
      s.type = 'text/javascript';
      s.src = 'https://www.googletagmanager.com/gtag/js?id=' + store.state.config.gaId;
      s.onload = s.onreadystatechange = () => {
        resolve();
      };
      s.onerror = (error) => {
        reject(error);
      }
      window.document.head.appendChild(s);
    });
  },
  setUp() {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    }
    window.gtag('js', new Date());
    window.gtag('config', store.state.config.gaId);
  }
}
